<template>
    <mavon-editor
            class="my-editor"
            ref="md"
            v-model="editor.value"
            @imgAdd="imgAdd"
            v-bind="editorOptions">
    </mavon-editor>
</template>

<script>

    import {mavonEditor} from 'mavon-editor'
    import 'mavon-editor/dist/css/index.css'
    import {whiteList as defaultWhiteList} from 'xss'

    import {upload} from '@/api/upload'

    export default {
        name: 'MarkdownEditor',
        props: {
            editor: Object
        },
        computed: {
            editorOptions() {
                const options = Object.assign({}, this.editor);
                const xssOptions = options.xssOptions && typeof options.xssOptions === 'object'
                    ? Object.assign({}, options.xssOptions)
                    : {};
                const baseWhiteList = xssOptions.whiteList || defaultWhiteList;
                const whiteList = Object.keys(baseWhiteList).reduce((acc, tag) => {
                    acc[tag] = Array.isArray(baseWhiteList[tag])
                        ? baseWhiteList[tag].slice()
                        : baseWhiteList[tag];
                    return acc;
                }, {});
                const imgAttrs = Array.isArray(whiteList.img)
                    ? whiteList.img
                    : ['src', 'alt', 'title', 'width', 'height'];

                whiteList.img = Array.from(new Set([
                    ...imgAttrs,
                    'referrerpolicy',
                    'loading'
                ]));
                options.xssOptions = Object.assign({}, xssOptions, {whiteList});
                return options;
            }
        },
        data() {
            return {}
        },
        mounted() {
            this.$set(this.editor, 'ref', this.$refs.md)
        },
        methods:
            {
                /*图片上传*/
                imgAdd(pos, $file) {
                    let that = this;
                    let formData = new FormData();
                    formData.append('image', $file);

                    upload(formData).then(res => {
                        // 第二步.将返回的url替换到文本原位置![...](./0) -> ![...](url)
                        if (res.data.success) {
                            that.$refs.md.$img2Url(pos, res.data.data);
                        } else {
                            that.$message({message: res.data.msg, type: 'error', showClose: true})
                        }

                    }).catch(err => {
                        that.$message({message: err, type: 'error', showClose: true});
                    })
                }
            },
        components:
            {
                mavonEditor
            }
    }
</script>
<style scoped>

    .my-editor {
        z-index: 6 !important;
    }

    .v-note-wrapper.fullscreen {
        top: 60px !important
    }
</style>
